import type { AnchorHTMLAttributes, FC, MouseEvent, PropsWithChildren } from "react";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";

import { useQuickLinksConfiguration } from "../QuickLinksConfigurationContext/QuickLinksConfigurationContext";

import styles from "./QuickLinksGroup.module.scss";

type QuickLinksGroupProps = {
  title: string;
  categories: Array<{
    title?: string;
    links?: Array<AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; label: string }>;
  }>;
};

export const QuickLinksGroup: FC<PropsWithChildren<QuickLinksGroupProps>> = ({ title, categories }) => {
  const { onClick: onQuickLinkClick } = useQuickLinksConfiguration();

  return (
    <div data-testid="quicklinks-category">
      {title && <h3 className={styles.title}>{title}</h3>}

      {categories.map(({ title, links = [] }, index) => {
        return (
          <div className={styles.group} key={index}>
            {title && <h4 className={styles.categoryTitle}>{title}</h4>}
            <ul className={styles.links}>
              {links.map(({ href, label, onClick, ...anchorAttributes }, index) => (
                <li key={index}>
                  <Button
                    {...anchorAttributes}
                    variant="text-muted"
                    size="sm"
                    href={href}
                    onClick={(ev: MouseEvent<HTMLAnchorElement>) => {
                      onClick?.(ev);
                      onQuickLinkClick(ev);
                    }}
                    iconAfter={LongArrowForwardIcon}
                  >
                    {label}
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
